import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import "../EasyPutAway.css";
import Modal from "@mui/material/Modal";
import {
  CmpTextField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { Typography } from "@mui/material";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";

const EasyPutawaySummaryModal = ({
  xOpen = false,
  fCloseEasyPutawaySummaryModal,
  xTitle = "",
  GRNNo = " ",
  GRNDate = " ",
  Loaction = " ",
  CardId = " ",
  PalletId = " ",
  ItemCd = " ",
  ItemName = " ",
  ModalCd = " ",
  RefNo = " ",
  GRNQty = "",
  PutAwayQty = " ",
  BalanceQty = " ",
  modalDataBin = [],
  onClick = () => {},
  
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  let xsLabel = 4;
  let xsColon = 0.2;
  let xsValue = 7.8;

  let mdLabel = "auto";
  let mdColon = 0.1;
  let mdValue = 3.9;
  let mdItemValue = 8;
  return (
    <Modal
      open={xOpen}
      onClose={fCloseEasyPutawaySummaryModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-easyPutAway-search"
      >
        <GCTitleSticky title={xTitle} onClose={fCloseEasyPutawaySummaryModal} />

        <div className="p-2">
          <Grid
            container
            spacing={0}
            className="align-items-center "
            colums={{ xs: 12, md: 12 }}
          >
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"GRN.No : " + GRNNo}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={3}>
                  <CmpTypographyField xcomponent={"span"} xText={"GRN.No"} />
                </Grid>
                <Grid item xs={8} md={6}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={GRNNo}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"GRNNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"GRN.Date : " + GRNDate}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={3}>
                  <CmpTypographyField xcomponent={"span"} xText={"GRN.Date"} />
                </Grid>
                <Grid item xs={8} md={6}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={GRNDate}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"GRNDate"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"Loation : " + Loaction}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={3}>
                  <CmpTypographyField xcomponent={"span"} xText={"Loaction"} />
                </Grid>
                <Grid item xs={8} md={6}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={Loaction}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"Loaction"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            className="align-items-center "
            colums={{ xs: 12, md: 12 }}
          >
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"CardId : " + CardId}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"CardId"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={CardId}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"CardId"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"PalletId"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={PalletId}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"PalletId"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"ItemCode : " + ItemCd}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"ItemCode"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={ItemCd}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"ItemCd"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"Item Name : " + ItemName}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={3}>
                  <CmpTypographyField xcomponent={"span"} xText={"Item Name"} />
                </Grid>
                <Grid item xs={8} md={9}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={ItemName}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"ItemName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"Moadal : " + ModalCd}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"Modal"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={ModalCd}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"ModalCd"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} xs={12}>
              {/* <CmpTypographyField
                xcomponent={"span"}
                xfontSize="15px"
                xText={"RefNo : " + RefNo}
              /> */}
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"RefNo"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={RefNo}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"RefNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"GRN Qty"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={GRNQty}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"GRNQty"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"Put-Away Qty"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={PutAwayQty}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"PutAwayQty"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0} className="align-items-center ">
                <Grid item xs={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"Balance Qty"} />
                </Grid>
                <Grid item xs={8} md={8}>
                  <CmpTextField
                    xtabIndex={"1"}
                    xValue={BalanceQty}
                    xVariant={"standard"}
                    xType={"text"} // text/number/password
                    xName={"BalanceQty"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid
            container
            spacing={{ xs: 1, md: 1 }}
            columns={{ xs: 12,  md: 12 }}
            className="mt-2"
          >
            { modalDataBin.map((obj,index) => (
              <Grid item xs={12}   md={4} key={index}>
                <Grid
                  container
                  spacing={0}
                  rowSpacing={0}
                  columnSpacing={0}
                  sx={{ 
                    borderWidth: "1px 1px 1px 5px",
                    borderStyle: "solid solid solid solid",
                    borderRadius: "0px 10px 10px 0px",
                    padding: "1px 2px 2px 8px",
                    marginTop: "2px",
                    borderColor: "#0d73bb",
 
                  }}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  onClick={()=>onClick(obj)}
                  className="PickingDetailCard"
                >
                  <Grid item xs={xsLabel} md={mdLabel}>
                    <CmpTypographyField xcomponent={"span"} xText={"Bin"} />
                  </Grid>
                  <Grid item xs={xsColon} md={mdColon}>
                    <CmpTypographyField xcomponent={"span"} xText={":"} />
                  </Grid>
                  <Grid item xs={xsValue} md={mdValue}>
                    <CmpTypographyField xcomponent={"span"} xText={obj?.binName} />
                  </Grid>
                  <Grid item xs={xsLabel} md={mdLabel}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Level"}
                    />
                  </Grid>
                  <Grid item xs={xsColon} md={mdColon}>
                    <CmpTypographyField xcomponent={"span"} xText={":"} />
                  </Grid>
                  <Grid item xs={xsValue} md={mdValue}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={obj?.Level}
                    />
                  </Grid>
                  <Grid item xs={xsLabel} md={mdLabel}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Aisle"}
                    />
                  </Grid>
                  <Grid item xs={xsColon} md={mdColon}>
                    <CmpTypographyField xcomponent={"span"} xText={":"} />
                  </Grid>
                  <Grid item xs={xsValue} md={mdValue}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={obj?.Aisle}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid> */}
          <Grid container spacing={1} className="easy-putaway-container mt-1">
            {modalDataBin.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                onClick={() => {
                  onClick(item);
                }}
              >
                <div className="easy-putaway-card">
                  <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        BinName
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={9}>
                      <Typography variant="body1" className="value">
                        {item.binName}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Level
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item.Level}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Aisle
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item.Aisle}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={6} md={9}>
                <Typography variant="body1" className="value">
                  {item.ItmName}
                </Typography>
              </Grid> */}
                  </Grid>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default EasyPutawaySummaryModal;
